import { render, staticRenderFns } from "./releaseConfirmation_page.vue?vue&type=template&id=87bc5aa6&scoped=true"
import script from "./releaseConfirmation_page.vue?vue&type=script&lang=js"
export * from "./releaseConfirmation_page.vue?vue&type=script&lang=js"
import style0 from "./releaseConfirmation_page.vue?vue&type=style&index=0&id=87bc5aa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bc5aa6",
  null
  
)

export default component.exports